import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { useLegacySearchTheme } from '@atlaskit/navigation-system/theming/use-legacy-search-theme';

import { ProductSearchInputSkeletonInteractiveSSR } from '@atlassian/product-search-dialog/skeleton';

import { useQuickFindEnabled } from '@confluence/navigation-search-dialog/entry-points/QuickFindExperiment.ts';
import { QuickFind } from '@confluence/navigation-search-dialog/entry-points/QuickFindAsync.ts';
import { LoadableAfterPaint } from '@confluence/loadable';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

const NavigationSearchDialogLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NavigationSearchDialog" */ '@confluence/navigation-search-dialog/entry-points/NavigationSearchDialog.ts'
			)
		).NavigationSearchDialog,
});

export const SearchBar = (): React.JSX.Element => {
	const theme = useLegacySearchTheme();
	const [isQuickFindEnabled] = useQuickFindEnabled();
	const renderServerPlaceholder = useRenderServerPlaceholder();

	const renderSearchBar = () => {
		return renderServerPlaceholder ? (
			<ProductSearchInputSkeletonInteractiveSSR
				placeholder="Search"
				advancedSearchUrl={`${CONTEXT_PATH}/search`}
				shouldFillContainer
			/>
		) : (
			<NavigationSearchDialogLoader shouldFillContainer theme={theme} />
		);
	};

	const renderQuickFind = () => <QuickFind />;

	return (
		<Box xcss={[searchBarWrapper, isQuickFindEnabled && flexStyles]}>
			{isQuickFindEnabled ? renderQuickFind() : renderSearchBar()}
		</Box>
	);
};

const searchBarWrapper = xcss({
	position: 'relative',
	width: '100%',
	maxWidth: '780px',
});

const flexStyles = xcss({
	display: 'flex',
	alignItems: 'center',
});
